import * as Sentry from '@sentry/react';

// Only initialize Sentry in production
if (import.meta.env.VITE_NODE_ENV === 'production') {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    beforeSend(event: any) {
      delete event.request?.data?.largePayload;
      return event;
    },
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    environment: 'production',
    // Add any additional configuration options here
  });
}

export default Sentry;
